import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_DELETE,
    MASTER_DATA_REMARK_INSERT,
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class RootCause extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Remark",
                    dataIndex: "remark",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, rootCauseDataSelectedEdit: data, rootCauseTitle: data.remark, rootCauseDescription: data.description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, rootCauseDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listRootCause: [],
            rootCauseTitle: '',
            rootCauseDescription: '',
            rootCauseDataSelectedEdit: {},
            rootCauseDataSelectedDelete: {},
            showWarningRootCauseTitle: false,
            showWarningRootCauseDescription: false,
            showPopupInfo: false,
            showAddModal: false,
            showEditModal: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateRootCause();
                this.getListRootCause(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateRootCause();
                this.getListRootCause(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateRootCause = () => {
        API_REMARK.getInitiateRootCause(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListRootCause = (current, pageSize) => {
        API_REMARK.getListRootCause(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listRootCause: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningRootCauseTitle: false,
            showWarningRootCauseDescription: false,
            rootCauseTitle: '',
            rootCauseDescription: ''
        });
    }

    handleConfirmAddRootCause = () => {
        if (!this.state.rootCauseTitle || !this.state.rootCauseDescription) {
            if (!this.state.rootCauseTitle) this.setState({ showWarningRootCauseTitle: true });
            if (!this.state.rootCauseDescription) this.setState({ showWarningRootCauseDescription: true });
            return;
        }
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddRootCause = () => {
        const data = {
            remark: this.state.rootCauseTitle,
            description: this.state.rootCauseDescription,
            category: 'Root Cause'
        }

        API_REMARK.postDataRemark(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        rootCauseTitle: '',
                        rootCauseDescription: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddRootCause = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateRootCause();
            this.getListRootCause(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditRootCause = () => {
        if (!this.state.rootCauseTitle || !this.state.rootCauseDescription) {
            if (!this.state.rootCauseTitle) this.setState({ showWarningRootCauseTitle: true });
            if (!this.state.rootCauseDescription) this.setState({ showWarningRootCauseDescription: true });
            return;
        }
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditRootCause = () => {
        const rootCauseId = this.state.rootCauseDataSelectedEdit.id;
        const data = {
            remark: this.state.rootCauseTitle,
            description: this.state.rootCauseDescription,
            category: 'Root Cause',
            category_id: this.state.rootCauseDataSelectedEdit.category_id,
            updated_at: this.state.rootCauseDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(rootCauseId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        rootCauseTitle: '',
                        rootCauseDescription: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditRootCause = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateRootCause();
            this.getListRootCause(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteRootCause = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const rootCauseId = this.state.rootCauseDataSelectedDelete.id;
        const data = {
            remark: this.state.rootCauseDataSelectedDelete.remark,
            category: 'Root Cause',
            updated_at: this.state.rootCauseDataSelectedDelete.updated_at
        }
        API_REMARK.deleteDataRemark(rootCauseId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteRootCause = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateRootCause();
            this.getListRootCause(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateRootCause();
        this.getListRootCause(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Root Cause"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  Root Cause Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-96 top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>Root Cause digunakan untuk penentuan asal masalah ketika akan menutup tiket.</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add Root Cause Button */}
                                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddrootcause" onClick={() => this.setState({ showAddModal: true })} className="flex items-center text-white py-2 px-6 rounded-md bg-nexcaredefault cursor-pointer">
                                            <IconAddTransparent />
                                            <span className="ml-2">Root Cause</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                {/* Table Root Cause */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listRootCause}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Root Cause Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Root Cause</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslrootcausetitleadd"
                                        className="form-control"
                                        placeholder="Tulis Remark"
                                        name="rootCauseTitle"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningRootCauseTitle: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.rootCauseTitle}
                                    />
                                    {this.state.showWarningRootCauseTitle && <MandatoryAlert text="Remark tidak boleh kosong!" />}
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslrootcausedescriptionadd"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="rootCauseDescription"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningRootCauseDescription: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.rootCauseDescription}
                                    />
                                    {this.state.showWarningRootCauseDescription && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddrootcause" onClick={this.handleConfirmAddRootCause}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Root Cause Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Root Cause</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslrootcausetitleedit"
                                        className="form-control"
                                        placeholder="Tulis Remark"
                                        name="rootCauseTitle"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningRootCauseTitle: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.rootCauseTitle}
                                    />
                                    {this.state.showWarningRootCauseTitle && <MandatoryAlert text="Remark tidak boleh kosong!" />}
                                </div>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslrootcausedescriptionedit"
                                        className="form-control"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="rootCauseDescription"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningRootCauseDescription: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.rootCauseDescription}
                                    />
                                    {this.state.showWarningRootCauseDescription && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditrootcause" onClick={this.handleConfirmEditRootCause}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Root Cause" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddRootCause} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddRootCause} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Root Cause" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditRootCause} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditRootCause} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Root Cause" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, rootCauseDataSelectedDelete: {} })} submit={this.handleDeleteRootCause} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteRootCause} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RootCause);